import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { sentryTools } from '@q-front-npm/tools';
import pkg from '../../../package.json';

export const initSentry = () => {
    if (import.meta.env.VITE_ENV === 'dev') {
        return;
    }
    Sentry.init({
        Vue: Vue,
        dsn: 'https://f1c3c4083f7848d4acfc7ac7423930f3@qm-front-sentry.wtzw.com/63',
        release: `${pkg.name}@${pkg.version}`,
        integrations: [Sentry.browserTracingIntegration()],
        autoSessionTracking: true,
        environment: import.meta.env.VITE_ENV,
        tracesSampleRate: import.meta.env.VITE_ENV === 'test' ? 1.0 : 0.1,
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            // Chrome 插件相关错误
            /chrome-extension:\/\//,
            /moz-extension:\/\//,
            /safari-extension:\/\//,
            // 常见的插件错误消息
            'Script error.',
            'Non-Error promise rejection captured',
            // 广告拦截器和其他插件常见错误
            'AdBlocker',
            'uBlock',
            'Adblock',
            // 其他插件相关错误
            'SecurityError: Permission denied'
        ],
        // 过滤错误事件
        beforeSend(event, hint) {
            // 过滤掉浏览器插件相关的错误
            if (sentryTools.checkExtensionRelated(event)) {
                return null; // 不发送此错误事件
            }
            if ((hint.originalException as Error)?.message?.includes('app版本不支持当前')) {
                return null;
            }
            return event; // 发送其他错误事件
        },
    });
};
